//Реакт
import React, { useState, useLayoutEffect, useContext } from "react";
import { useSelector } from "react-redux";
//Библиотеки и Api
import ViewHandler from "../../../../../inc/ViewHandler";
import ApiBooking from "../../../../../app/api/authorized/admin/booking/ApiBooking";
import { route } from "../../../../../inc/Routes";
import DateLib from "../../../../../inc/DateLib";
//Модули Content
import Page from "../../../../modules/page";
import { ContextPage } from "../../../../modules/page/pageContext";
import { ContextContent } from "../../../../modules/content/contentContext";
//Модули view
import List from "../../../../modules/list";
import ListHeaderItem from "../../../../modules/list/__header-item";
import ListBodyItem from "../../../../modules/list/__body-item";
//Компоненты
import InputText from "../../../../components/inputs/text";
import Select from "../../../../components/inputs/select";
import ButtonLinkShow from "../../../../components/button-link/__show/button-link__show";
import InputNumber from "../../../../components/inputs/number/number";
import MultiSelect from "../../../../components/inputs/milti-select";
//Mui icons
import NumbersIcon from '@mui/icons-material/Numbers';
import ListAltIcon from '@mui/icons-material/ListAlt';
import PersonIcon from '@mui/icons-material/Person';
import TodayIcon from '@mui/icons-material/Today';
import InsertInvitationIcon from '@mui/icons-material/InsertInvitation';
import TimelapseIcon from '@mui/icons-material/Timelapse';
import ShopTwoIcon from '@mui/icons-material/ShopTwo';
import FmdBadIcon from '@mui/icons-material/FmdBad';
import CreditScoreIcon from '@mui/icons-material/CreditScore';
import PlaylistAddCheckCircleIcon from '@mui/icons-material/PlaylistAddCheckCircle';
import CommentIcon from '@mui/icons-material/Comment';
//Стили
import './styles.css';

export default function BookingIndex({ ...other }) {
    return <Page {...other}>
        <BookingIndexContent {...other} />
    </Page>
}

function BookingIndexContent({ ...other }) {
    const contextContent = useContext(ContextContent);
    const contextPage = useContext(ContextPage);

    const [_id, set_id] = useState('');
    const [_fio, set_fio] = useState('');
    const [_typeId, set_typeId] = useState('');
    const [_statusId, set_statusId] = useState('');
    const [_comment, set_comment] = useState('');
    const [_paymentTypes, set_paymentTypes] = useState([])

    const handleTypeChange = (event) => {
        set_typeId(event.target.value)
    }

    const handleStatusChange = (event) => {
        set_statusId(event.target.value)
    }

    const handlePaymentTypeChange = (event) => {
        set_paymentTypes(event.target.value);
    };

    const types = useSelector(state => state.commonOption.bookingTypes);
    const statuses = useSelector(state => state.commonOption.bookingStatuses);
    const paymentTypes = useSelector(state => state.commonOption.paymentTypes);

    useLayoutEffect(() => {
        contextPage.setTitle(`Бронирования`);
        contextContent.setTitle(`Бронирования`);
    }, [contextContent, contextPage]);
    const header = [
        <ListHeaderItem
            key="create"
            name="create"
            isSort={false}
            className="create_mobile"
        >
        
        </ListHeaderItem>,
        <ListHeaderItem
            key="order_id"
            name="order_id"
        >
            <div className="header-row__center">
                <ListAltIcon/>
                <div className="header-row__center_text">Заказ</div> 
            </div>  
        </ListHeaderItem>,
        <ListHeaderItem
            key="user"
            name="user"
        >
            <div className="header-row__center">
                <PersonIcon/>
                <div className="header-row__center_text">Пользователь</div> 
            </div>  
        </ListHeaderItem>,
        <ListHeaderItem
            key="date_start"
            name="date_start"
        >
            <div className="header-row__center">
                <TodayIcon/>
                <div className="header-row__center_text">Начало</div> 
            </div> 
        </ListHeaderItem>,
        <ListHeaderItem
            key="date_end"
            name="date_end"
        >
            <div className="header-row__center">
                <InsertInvitationIcon/>
                <div className="header-row__center_text">Окончание</div> 
            </div> 
        </ListHeaderItem>,
        <ListHeaderItem
            key="minutes"
            name="minutes"
        >
            <div className="header-row__center">
                <TimelapseIcon/>
                <div className="header-row__center_text">Минуты</div> 
            </div> 
        </ListHeaderItem>,
        <ListHeaderItem
            key="type_id"
            name="type_id"
        >
            <div className="header-row__center">
                <ShopTwoIcon/>
                <div className="header-row__center_text">Приобритен через</div> 
            </div> 
        </ListHeaderItem>,
        <ListHeaderItem
            key="status_id"
            name="status_id"
        >
            <div className="header-row__center">
                <FmdBadIcon/>
                <div className="header-row__center_text">Статус бронирования</div> 
            </div> 
        </ListHeaderItem>,
        <ListHeaderItem
            key="payment"
            name="payment"
            isSort={false}
        >
            <div className="header-row__center">
                <CreditScoreIcon/>
                <div className="header-row__center_text">Оплата</div> 
            </div> 
        </ListHeaderItem>,
        <ListHeaderItem
            key="check_status_id"
            name="check_status_id"
        >
            <div className="header-row__center">
                <PlaylistAddCheckCircleIcon/>
                <div className="header-row__center_text">Проверка</div> 
            </div> 
        </ListHeaderItem>,
        <ListHeaderItem
            key="comment"
            name="comment"
        >
            <div className="header-row__center">
                <CommentIcon/>
                <div className="header-row__center_text">Комментарий</div> 
            </div> 
            
        </ListHeaderItem>,
        <ListHeaderItem
            key="id"
            name="id"
        >
            <div className="header-row__center">
                <NumbersIcon/>
                <div className="header-row__center_text">Номер</div> 
            </div>  
        </ListHeaderItem>,
    ];

    const filters = [
        <InputText className="input_wf" value={_fio} onChange={(e) => { set_fio(e.target.value) }}>Пользователь</InputText>,
        <Select className="input_wf" options={types} value={_typeId} onChange={handleTypeChange}>Приобретен через</Select>,
        <Select className="input_wf" options={statuses} value={_statusId} onChange={handleStatusChange}>Статус</Select>,
        <MultiSelect className="input_wf option-border-none" options={paymentTypes} value={_paymentTypes} onChange={handlePaymentTypeChange}>Тип оплаты</MultiSelect>,
        <InputText className="input_wf"  value={_comment} onChange={(e) => { set_comment(e.target.value) }}>Комментарий</InputText>,
        <InputNumber className="input_wf" value={_id} onChange={(e) => { set_id(e.target.value) }}>Номер</InputNumber>,
    ];

    const renderRow = (row, i) => {
        return [
            <ListBodyItem className="admin-bookings_column-width" key="show" data-label={ViewHandler.getComponentTextByClass(header[0].props.children, 'header-row__center_text')}>
                {contextContent.checkPermission('show') ? <ButtonLinkShow target="_blank" href={contextPage.routes.show.url({ id: row.id })} /> : null}
            </ListBodyItem>,
            <ListBodyItem className="admin-bookings_column-width" key="order_id" data-label={ViewHandler.getComponentTextByClass(header[1].props.children, 'header-row__center_text')}><a target="_blank" href={route(`authorized.admin.order.bookings.show`,{id: row.order_id })}>{ row.order_id }</a></ListBodyItem>,
            <ListBodyItem className="admin-bookings_column-width" key="user" data-label={ViewHandler.getComponentTextByClass(header[2].props.children, 'header-row__center_text')}><a href={route(`authorized.admin.user.users.show`,{id: row.user_id})}>{row.user_fio}</a></ListBodyItem>,
            <ListBodyItem className="admin-bookings_column-width" key="date_start" data-label={ViewHandler.getComponentTextByClass(header[3].props.children, 'header-row__center_text')}>{DateLib.formatterDateTime(row.date_start)}</ListBodyItem>,
            <ListBodyItem className="admin-bookings_column-width" key="date_end" data-label={ViewHandler.getComponentTextByClass(header[4].props.children, 'header-row__center_text')}>{DateLib.formatterDateTime(row.date_end)}</ListBodyItem>,
            <ListBodyItem className="admin-bookings_column-width" key="minutes" data-label={ViewHandler.getComponentTextByClass(header[5].props.children, 'header-row__center_text')}>{row.minutes}</ListBodyItem>,
            <ListBodyItem className="admin-bookings_column-width" key="type_id" data-label={ViewHandler.getComponentTextByClass(header[6].props.children, 'header-row__center_text')}>
                <div>
                    {row.type_name}
                </div>
                <div>
                    {row.certificate.id ? <a target="_blank" href={route('authorized.admin.order.certificates.show', {id: row.certificate.id })}>{row.certificate.code}</a> : null}
                </div>
            </ListBodyItem>,
            <ListBodyItem className="admin-bookings_column-width" key="status_id" data-label={ViewHandler.getComponentTextByClass(header[7].props.children, 'header-row__center_text')}>{row.status_name}</ListBodyItem>,
            <ListBodyItem className="admin-bookings_column-width" key="payment" data-label={ViewHandler.getComponentTextByClass(header[8].props.children, 'header-row__center_text')}>
                {row.order_total ? <div>{row.order_total} ₽</div> : null}
                {row.balance_user_name ? <div>{row.balance_user_name}</div> : null}
                {row.time_minutes ? <div>{row.time_minutes}</div> : null}
                {row.time_status_comment ? <div className="admin-bookings__time-pay-status">{row.time_status_comment}</div> : null}
            </ListBodyItem>,
            <ListBodyItem className="admin-bookings_column-width" key="check_status_id" data-label={ViewHandler.getComponentTextByClass(header[9].props.children, 'header-row__center_text')}>{row.check_status_name}</ListBodyItem>,
            <ListBodyItem className="admin-bookings_column-width" key="comment" data-label={ViewHandler.getComponentTextByClass(header[10].props.children, 'header-row__center_text')}>{row.comment}</ListBodyItem>,
            // <ListBodyItem className="admin-bookings_column-width" key="count_people" data-label={header[11].props.children}>{row.count_people}</ListBodyItem>,
            <ListBodyItem className="admin-bookings_column-width" key="id" data-label={ViewHandler.getComponentTextByClass(header[11].props.children, 'header-row__center_text')}>{row.id}</ListBodyItem>,
        ];
    }
    return <>
        <List
            header={header}
            filters={filters}
            ApiModel={ApiBooking}
            renderRow={renderRow}
            searchParams={{ id: _id, user_fio: _fio, type: _typeId, status: _statusId, paymentTypes: _paymentTypes, comment: _comment }}
        />
    </>
}
